import { Component, Input, Output, EventEmitter, OnInit, AfterViewChecked, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PotentialPerRegionMapComponent } from '../../pages/national/components/potential-per-region-map/potential-per-region-map.component';
import { HeatmapInclusionProcessComponent } from '../../pages/national/components/heatmap-inclusion-process/heatmap-inclusion-process.component';
import { RegionalAccessActivityPlanTableComponent } from '../../pages/national/components/regional-access-activity-plan-table/regional-access-activity-plan-table.component';
import { OpenToAccessCurveComponent } from '../../pages/national/components/open-to-access-curve/open-to-access-curve.component';
import { OpenToMarketCurveComponent } from '../../pages/national/components/open-to-market-curve/open-to-market-curve.component';
import { MapOpenToAccessRegionsComponent } from '../../pages/national/components/map-open-to-access-regions/map-open-to-access-regions.component';
import { Tooltip } from 'flowbite';
import type { TooltipOptions, TooltipInterface } from 'flowbite';
import type { InstanceOptions } from 'flowbite';
import { EvolutionRegionalAccessComponent } from "../../pages/national/components/evolution-regional-access/evolution-regional-access.component";
import { MonitoringForecastVsActualRegionalLevelComponent } from '../../pages/national/components/monitoring-forecast-vs-actual-regional-level/monitoring-forecast-vs-actual-regional-level.component';
import { NtForecastTimeProgressComponent } from "../../pages/national/components/nt-forecast-time-progress/nt-forecast-time-progress.component";
import { GenerateExcelComponent } from '../../pages/national/components/generate-excel/generate-excel.component';
import { LoadingGenerationComponent } from '../../pages/national/components/loading-generation/loading-generation.component';
import { NHospitalsAndExperiencesComponent } from '../../pages/national/components/n-hospitals-and-experiences/n-hospitals-and-experiences.component';

@Component({
  selector: 'app-card-widget',
  standalone: true,
  imports: [
    CommonModule,
    PotentialPerRegionMapComponent,
    HeatmapInclusionProcessComponent,
    RegionalAccessActivityPlanTableComponent,
    OpenToAccessCurveComponent,
    OpenToMarketCurveComponent,
    MapOpenToAccessRegionsComponent,
    EvolutionRegionalAccessComponent,
    MonitoringForecastVsActualRegionalLevelComponent,
    NtForecastTimeProgressComponent,
    GenerateExcelComponent,
    LoadingGenerationComponent,
    NHospitalsAndExperiencesComponent
],
  templateUrl: './card-widget.component.html',
  styleUrl: './card-widget.component.css',
})
export class CardWidgetComponent implements OnInit, AfterViewChecked {
  @Input() title = '';
  @Input() className = '';
  @Input() isEdit: boolean = false;
  @Input() widgetId!: number;
  @Input() extendWidget:boolean=false;
  @Input() isDrag:boolean=false;

  @Output() deleteWidget = new EventEmitter<number>();
  @Output() openModalAddActivities = new EventEmitter<boolean>();
  @Output() openAccessCurve = new EventEmitter<boolean>(); 
  @Output() openMarketCurve = new EventEmitter<boolean>(); 


  deleteModalOpen: boolean = false;

  private tooltipsInitialized = false;

  // for evoluzione widget
  isEvoluzioneTwoRowsLayout: boolean = false;

  generateExcel:boolean=false;
  canGenerateExcel:boolean=false; // this will take value from the output of the loading pop up
  @ViewChild(LoadingGenerationComponent) loadingComponent!: LoadingGenerationComponent;


  openModalDelete(status: boolean) {
    this.deleteModalOpen = status;
    if (this.deleteModalOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.width = '';
    }
  }

  onDelete() {
    this.deleteWidget.emit(this.widgetId);
    document.body.style.overflow = '';
    document.body.style.width = '';
  }

  ngOnInit(): void {
    this.tooltipConfig();
  }

  ngAfterViewChecked(): void {
    const triggers = document.querySelectorAll('.tooltip-trigger');
    const contents = document.querySelectorAll('.tooltip-content');

    // if not visible tooltips reset the flag
    if (triggers.length === 0 || contents.length === 0) {
      this.tooltipsInitialized = false;
    }

    if (!this.tooltipsInitialized && triggers.length && contents.length) {
      this.tooltipConfig();
      this.tooltipsInitialized = true;
    }
  }

  tooltipConfig(): void {
    const triggerElements = document.querySelectorAll<HTMLElement>('.tooltip-trigger');
    const contentElements = document.querySelectorAll<HTMLElement>('.tooltip-content');

    triggerElements.forEach((triggerEl, index) => {
      const contentEl = contentElements[index];

      if (contentEl && triggerEl) {
        const options: TooltipOptions = {
          placement: 'top',
          triggerType: 'hover',
       /*   onHide: () => console.log('tooltip is hidden'),
          onShow: () => console.log('tooltip is shown'),
          onToggle: () => console.log('tooltip is toggled'),*/
        };

        const instanceOptions: InstanceOptions = {
          id: `tooltip-${index}`,
          override: true,
        };

        new Tooltip(contentEl, triggerEl, options, instanceOptions);
      }
    });
  }

  openModalAddActivity(value:boolean){
      this.openModalAddActivities.emit(value); 
  }

 openAccessCurveFromChild(isAccessCurveOpen: boolean) {
    this.openAccessCurve.emit(isAccessCurveOpen);
  }

   openMarketCurveFromChild(isMarketCurveOpen: boolean) {
    this.openMarketCurve.emit(isMarketCurveOpen);
  }
getTooltipText(): string {
  switch (this.className) {
    case 'widget-esperienze-map':
      return 'Esperienze potenziali per singola Regione';
    case 'widget-heatmap':
      return 'Rappresentazione visiva dell\'apertura a livello Ospedaliero per ogni singola Regione';
    case 'widget-mapOpenAccess':
      return 'Rappresentazione visiva dell\'accesso puro a livello Regionale, senza il dettaglio di apertura a livello Ospedaliero';
    case 'widget-curva-accesso':
      return 'Accesso puro a livello Regionale, ovvero inserimento in prontuario Regionale o delibera di livello Regionale o delibera dei centri prescrittori';
    case 'widget-curva-mercato':
      return 'Apertura a livello Ospedaliero, ovvero inserimento a livello Locale con concreta e materiale apertura a livello di Centro Ospedaliero';
    case 'widget-evolution-regional-access':
      return 'Accesso a livello delle singole Regioni nel corso del tempo, senza il dettaglio di apertura a livello Ospedaliero';
    case 'widget-monitoringForecastVsActualRegionalLevel':
      return 'Confronto temporale, in termini di mesi, tra Forecast e Actual a livello di Accesso Regionale';
      case 'widget-forecastTimeProgress':
      return 'Progresso temporale, con una comparazione in giorni tra la data di Forecast in Accesso Regionale e la data odierna'
      case 'widget-attivita':
      return 'Aggregazione di livello Nazionale di tutte le attività e tattiche inserite nei piano di Accesso Regionali e Locali';
      case 'widget-nHospitalsAndExperiences':
      return 'Esperienze potenziali a livello nazionale e numero totale di Ospedali sul territorio'
      default:
      return '';
  }
}

getTooltipWidthClass(): string {
  switch (this.className) {
    case 'widget-esperienze-map':
      return 'w-[160px]';
    case 'widget-heatmap':
      return 'w-[180px]';
    case 'widget-mapOpenAccess':
      return 'w-[210px]';
    case 'widget-curva-accesso':
      return 'w-[190px]';
    case 'widget-curva-mercato':
      return 'w-[190px]';
    case 'widget-evolution-regional-access':
      return 'w-[205px]';
    case 'widget-monitoringForecastVsActualRegionalLevel':
      return 'w-[180px]';
      case 'widget-forecastTimeProgress':
      return 'w-[210px]';
      case 'widget-attivita':
      return 'w-[200px]'
    default:
      return 'w-[200px]';
  }
}

generateReport(status:boolean){
  this.generateExcel=status
  console.log("GENERATE EXCEL?",this.generateExcel)
  document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
 setTimeout(() => {
 this.canGenerateExcel=true;
console.log("genera",this.canGenerateExcel);
}, 2000);
}

onEndMessage(event: Event) {
    console.log('Evento ricevuto dal figlio:', event);
    this.loadingComponent.endingMessage()
       setTimeout(() => {
        this.generateExcel=false;
        this.canGenerateExcel=false;
         document.body.style.overflow = '';
      document.body.style.width = '';
    }, 1000);
}

}
